// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader@6.8.1_webpack@5.86.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@6.8.1_webpack@5.86.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShogiPlayer .ShortcutViewer{position:fixed;top:0;left:0;right:0;bottom:0;overflow:auto;z-index:2;background-color:#00000080;display:flex;align-items:center;justify-content:center;flex-direction:column}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
